import { forwardRef } from 'react';
import { Flex } from './Flex';
import type { FlexProps } from './Flex.types';

const HFlex = forwardRef<HTMLDivElement, FlexProps>(({ ...props }, ref) => {
  return <Flex ref={ref} width="100%" direction="row" {...props} />;
});

HFlex.displayName = 'HFlex';

export { HFlex };
